module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$p('measurement/measurement')) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "play-button-form"
  }, [_c('div', {
    staticClass: "play-button-header"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/measuringTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onMeasuringChanged
    },
    model: {
      value: (_vm.measuringActive),
      callback: function($$v) {
        _vm.measuringActive = $$v
      },
      expression: "measuringActive"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/noiseTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.noiseError),
      expression: "!getStatus.noiseError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onNoiseChanged
    },
    model: {
      value: (_vm.noiseActive),
      callback: function($$v) {
        _vm.noiseActive = $$v
      },
      expression: "noiseActive"
    }
  }), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.noiseError),
      expression: "getStatus.noiseError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onNoiseChanged
    },
    model: {
      value: (_vm.noiseActive),
      callback: function($$v) {
        _vm.noiseActive = $$v
      },
      expression: "noiseActive"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/weatherTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.weatherError),
      expression: "!getStatus.weatherError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onWeatherChanged
    },
    model: {
      value: (_vm.weatherActive),
      callback: function($$v) {
        _vm.weatherActive = $$v
      },
      expression: "weatherActive"
    }
  }, [_vm._v("ja")]), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.weatherError),
      expression: "getStatus.weatherError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onWeatherChanged
    },
    model: {
      value: (_vm.weatherActive),
      callback: function($$v) {
        _vm.weatherActive = $$v
      },
      expression: "weatherActive"
    }
  }, [_vm._v("ne")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "play-button-row"
  }, [_c('el-col', {
    staticClass: "play-button-label",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.$l('dashboard/adioTgl')))]), _vm._v(" "), _c('el-col', {
    staticClass: "play-button-switch",
    attrs: {
      "span": 12
    }
  }, [_c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getStatus.adioError),
      expression: "!getStatus.adioError"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onAdioChanged
    },
    model: {
      value: (_vm.adioActive),
      callback: function($$v) {
        _vm.adioActive = $$v
      },
      expression: "adioActive"
    }
  }, [_vm._v("ja")]), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getStatus.adioError),
      expression: "getStatus.adioError"
    }],
    attrs: {
      "on-color": "#e43a45",
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.onAdioChanged
    },
    model: {
      value: (_vm.adioActive),
      callback: function($$v) {
        _vm.adioActive = $$v
      },
      expression: "adioActive"
    }
  }, [_vm._v("ne")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b5b46a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/PlayPopover.vue
// module id = 460
// module chunks = 1